'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('governanceProcessModule')

.factory('grcGovernanceProcessService', ['$http', '$q', function ($http, $q) {
    var baseUrl = environment.apiUrl + '/Pilot/api/GovernanceProcess';

    var service = {};

    service.getById = function (governanceProcessId) {
        return $http
            .get(baseUrl + '/' + governanceProcessId)
            .then(function (response) { return response.data; });
    };

    service.getActiveProcesses = function () {
        return $http
            .get(baseUrl + '/Active')
            .then(function (response) { return response.data; });
    };

    service.getRiskSelfAssessments = function () {
        return $http
            .get(baseUrl + '/RiskSelfAssessments')
            .then(function (response) { return response.data; });
    };

    service.getActiveRiskSelfAssessments = function () {
        return $http
            .get(baseUrl + '/RiskSelfAssessments/Active')
            .then(function (response) { return response.data; });
    };

    service.getARICProcesses = function () {
        return $http
            .get(baseUrl + '/ARIC')
            .then(function (response) { return response.data; });
    };

    service.getActiveARIC = function () {
        return $http
            .get(baseUrl + '/ARIC/Active')
            .then(function (response) { return response.data; });
    };

    service.getInitiativeUpdateStatusProcesses = function () {
        return $http
            .get(baseUrl + '/InitiativeUpdateStatus')
            .then(function (response) { return response.data; });
    };

    service.getActiveInitiativeUpdateStatus = function () {
        return $http
            .get(baseUrl + '/InitiativeUpdateStatus/Active')
            .then(function (response) { return response.data; });
    };

    service.getAuditMandateProcesses = function () {
        return $http
            .get(baseUrl + '/AuditMandate')
            .then(function (response) { return response.data; });
    };

    service.getProcessTypes = function () {
        return $http
            .get(baseUrl + '/Type')
            .then(function (response) { return response.data; });
    };

    service.getFiscalYears = function () {
        return $http
            .get(baseUrl + '/FiscalYear')
            .then(function (response) { return response.data; });
    };

    return service;
}]);
